import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from '../9837bffb195015a4513e93472fb398acea449d84d98f6268afd87828b663e6c1.cfe-internal.js';
import '../../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../Checkbox/7c01f064e737dc18a24ac444b04d862febcacfe2a972f7a6e0ab6cb80ee8df17.cfe-internal.js';
import wrapEvent from '../../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';
import Checkbox from '../../Checkbox/bbb86efee75a495b2eb803aad8b5e8c05236c93f8c0727ac51f1a82b7608b17b.cfe-internal.js';

var _excluded = ["role", "tabIndex", "children", "className", "disabled", "onSelect", "onKeyDown", "onClick", "isSelected", "isHighlighted", "isMultiSelect", "isSelectable"];
var MenuItem = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var role = _ref.role,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex,
    label = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    onSelect = _ref.onSelect,
    onKeyDown = _ref.onKeyDown,
    onClick = _ref.onClick,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$isHighlighted = _ref.isHighlighted,
    isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
    _ref$isMultiSelect = _ref.isMultiSelect,
    isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
    _ref$isSelectable = _ref.isSelectable,
    isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
    rest = _objectWithoutProperties(_ref, _excluded);
  var defaultRole = isSelectable ? isMultiSelect ? 'menuitemcheckbox' : 'menuitemradio' : 'menuitem';
  var handleSelect = function handleSelect(e) {
    if (typeof onSelect === 'function' && !disabled) {
      onSelect(e);
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", _extends({}, rest, {
      ref: ref,
      role: role !== null && role !== void 0 ? role : defaultRole,
      tabIndex: tabIndex,
      "aria-disabled": disabled,
      "aria-checked": isSelectable ? isSelected : undefined,
      className: classNames(className, styles.menuItem, _defineProperty(_defineProperty({}, styles.focus, isHighlighted), styles.selected, isSelected)),
      onKeyDown: wrapEvent(onKeyDown, function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          handleSelect(e);
          e.preventDefault(); // prevent scroll
        }
      }),
      onClick: wrapEvent(onClick, handleSelect)
    }), isMultiSelect && /*#__PURE__*/React__default.createElement(Checkbox, {
      "aria-hidden": true,
      className: classNames(styles.checkbox, _defineProperty({}, styles.highlighted, isHighlighted && !isSelected)),
      checked: isSelected,
      onChange: function onChange() {
        /* noop*/
      }
    }), label)
  );
});
var MenuItem$1 = MenuItem;

export { MenuItem$1 as default };
